import * as React from 'react'
import { SignupContextValue } from '../types'

export const SignupContext = React.createContext<SignupContextValue>({
  // values
  step: 0,
  acceptNewsletter: false,
  acceptTerms: false,
  businessRole: '',
  companyName: '',
  email: '',
  message: '',
  operatingSystem: '',
  productName: '',
  productVariant: '',

  // actions
  setStep: () => { },
  setAcceptNewsletter: () => { },
  setAcceptTerms: () => { },
  setBusinessRole: () => { },
  setCompanyName: () => { },
  setEmail: () => { },
  setMessage: () => { },
  setOperatingSystem: () => { },
  setProductName: () => { },
  setProductVariant: () => { },
})

export const useSignupContext = () => React.useContext(SignupContext)

export const SignupProvider = ({ children }: { children: React.ReactNode }) => {
  const [step, setStep] = React.useState(0)
  const [productName, setProductName] = React.useState('')
  const [productVariant, setProductVariant] = React.useState('')
  const [operatingSystem, setOperatingSystem] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [companyName, setCompanyName] = React.useState('')
  const [businessRole, setBusinessRole] = React.useState('')
  const [message, setMessage] = React.useState('')
  const [acceptNewsletter, setAcceptNewsletter] = React.useState(false)
  const [acceptTerms, setAcceptTerms] = React.useState(false)

  const value: SignupContextValue = {
    step,
    acceptNewsletter,
    acceptTerms,
    businessRole,
    companyName,
    email,
    message,
    operatingSystem,
    productName,
    productVariant,
    setStep,
    setAcceptNewsletter,
    setAcceptTerms,
    setBusinessRole,
    setCompanyName,
    setEmail,
    setMessage,
    setOperatingSystem,
    setProductName,
    setProductVariant,
  }

  return <SignupContext.Provider value={value}>{children}</SignupContext.Provider>
}
